<template>
    <div>
        <div class="container-fluid">

            <div v-if="dataFetch" class="d-block pt-5">
                <div class="row justify-content-center">
                    <p>Loading...</p>
                </div>
            </div>

            <div v-if="!dataFetch">
                <div class="d-block pt-5 mb-3">
                    <div class="row">
                        <div class="col">
                            <div class="d-flex align-items-center mb-3 flex-1">
                                <div class="d-block me-3">
                                    <div class="avatar">
                                        <span class="avatar-title rounded-circle bg-white text-dark"><i class="fa-solid fa-user fa-lg m-0"></i></span>
                                    </div>
                                </div>
                                <div class="d-block overflow-hidden">
                                    <div class="d-block h1 m-0 display-tektur block-ellipsis">{{ dataUsers.fullname }}</div>
                                    <div class="d-block">{{ dataUsers.school_name }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-white-naked btn-s-1 me-3" v-on:click="goDetail">
                                    <div class="btn-s-1-inner">Tutup</div>
                                </button>
                                <button type="button" class="btn btn-white btn-s-1" v-on:click="printRationalization" :disabled="fetch_download">
                                    <div class="btn-s-1-inner">
                                        <i v-if="!fetch_download" class="fa-solid fa-print me-3"></i>
                                        <i v-if="fetch_download" class="fa-solid fa-spin fa-spinner me-3"></i>
                                        {{ fetch_download ? 'Harap tunggu ...' : 'Cetak Rasionalisasi' }} </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-for="(item, index) in dataEvaluation" :key="index">
                    <div class="card">
                        <div class="card-body">
                            <div class="row align-items-center">
                                <div class="col-md-8">
                                    <div class="d-block font-bold text-neon mb-3">Skor Bobot Rasionalisasi</div>
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="d-flex align-items-center justify-content-between overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis">Index Nilai</div>
                                                <div class="text-right">{{item.index_score}}%</div>
                                            </div>
                                            <div class="d-flex align-items-center justify-content-between overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis">Index SNBP</div>
                                                <div class="text-right">{{item.index_snbp}}%</div>
                                            </div>
                                            <div class="d-flex align-items-center justify-content-between overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis">Index SNBT</div>
                                                <div class="text-right">{{item.index_snbt}}%</div>
                                            </div>
                                            <div class="d-flex align-items-center justify-content-between overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis">Index Prestasi</div>
                                                <div class="text-right">{{item.index_achievement}}%</div>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="d-flex align-items-center justify-content-between overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis">Index Universitas</div>
                                                <div class="text-right">{{item.index_university}}%</div>
                                            </div>
                                            <div class="d-flex align-items-center justify-content-between overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis">Index Jurusan</div>
                                                <div class="text-right">{{item.index_major}}%</div>
                                            </div>
                                            <div class="d-flex align-items-center justify-content-between overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis">Index Akreditasi</div>
                                                <div class="text-right">{{item.index_accreditation}}%</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="d-block h-100 ps-md-3">
                                        <div class="d-block me-4 mb-2">
                                            <div class="d-block h3 mb-1">{{ item.university_name }} - {{ item.major_fullname }}</div>
                                            <div class="d-block m-0 text-sm">Peluang Kompetisi</div>
                                        </div>
                                        <div class="d-flex align-items-start">
                                            <div class="d-block text-xlg display-tektur">
                                                {{item.opportunity}}%
                                            </div>
                                            <div class="d-block pt-3 ps-3">
                                                <div v-if="item.opportunity < 50" class="box-skewed bg-danger">SANGAT RENDAH</div>
                                                <div v-else-if="item.opportunity >= 50 && item.opportunity < 60" class="box-skewed bg-danger">RENDAH</div>
                                                <div v-else-if="item.opportunity >= 60 && item.opportunity < 70" class="box-skewed bg-warning">SEDANG</div>
                                                <div v-else-if="item.opportunity >= 70 && item.opportunity < 80" class="box-skewed bg-success">TINGGI</div>
                                                <div v-else-if="item.opportunity >= 80 && item.opportunity < 90" class="box-skewed bg-success">SANGAT TINGGI</div>
                                                <div v-else-if="item.opportunity >= 90" class="box-skewed bg-primary">EXCELLENT</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card bg-card-trans" v-if="item.statistic.id">
                        <div class="card-body pb-0">
                            <div class="row">
                                <div class="col-4">
                                    <div class="d-block font-bold text-pink mb-3">Data Detail Jurusan</div>
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis text-sm">Nilai SNBP</div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                    <div class="display-tektur text-md m-0">
                                                        {{ item.statistic.pg_rapor }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis text-sm">Kuota SNBP</div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                    <div class="display-tektur text-md m-0">{{ item.statistic.snbp_quota }}</div>
                                                </div>
                                            </div>
                                            <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis text-sm">Peminat SNBP</div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                    <div class="display-tektur text-md m-0">{{ item.statistic.snbp_applicants }}</div>
                                                </div>
                                            </div>
                                            <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis text-sm">Persaingan SNBP</div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                    <div class="display-tektur text-md m-0">1:{{ item.statistic.snbp_comparison }}</div>
                                                </div>
                                            </div>
                                            <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis text-sm">Nilai Rapor Saya</div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                    <div class="display-tektur text-md m-0" v-for="(itemEvaluation, indexEvaluation) in dataEvaluation" :key="indexEvaluation" >{{ itemEvaluation.avg_score_subject }}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis text-sm">Nilai SNBT</div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                    <div class="display-tektur text-md m-0">
                                                        {{ item.statistic.pg_utbk }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis text-sm">Kuota SNBT</div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                    <div class="display-tektur text-md m-0">{{ item.statistic.snbt_quota }}</div>
                                                </div>
                                            </div>
                                            <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis text-sm">Peminat SNBT</div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                    <div class="display-tektur text-md m-0">{{ item.statistic.snbt_applicants }}</div>
                                                </div>
                                            </div>
                                            <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis text-sm">Persaingan SNBT</div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                    <div class="display-tektur text-md m-0">1:{{ item.statistic.snbt_comparison }}</div>
                                                </div>
                                            </div>
                                            <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis text-sm">Nilai Prasyarat Saya</div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                    <div class="display-tektur text-md m-0" v-for="(itemEvaluation, indexEvaluation) in dataEvaluation" :key="indexEvaluation" >{{ itemEvaluation.avg_score_prerequisite }}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12" v-if="dataMajorRank.total_data > 0">
                                            <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                                <div class="block-ellipsis text-sm">Peringkat Jurusan di Sekolah</div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                    <div v-if="dataMajorRank.my_rank != '-'" class="display-tektur text-md m-0">{{ dataMajorRank.my_rank }} dari {{ dataMajorRank.total_data }}</div>
                                                    <div v-if="dataMajorRank.my_rank == '-'" class="display-tektur text-md m-0">Peringkat belum diketahui</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <RadarChart :width="310" :height="310" :chart-data="dataChartRecap" :chart-id="'radar-nilai'"/>
                                    <small>
                                        Keterangan:
                                        <ul class="mt-3" v-for="(labelItem, labelIndex) in description_labels" :key="labelIndex">
                                            <li>{{ labelItem }}</li>
                                        </ul>
                                    </small>
                                </div>
                                <div class="col-4">
                                    <div class="d-block font-bold text-pink mb-3">Rekap Perbandingan Nilai</div>
                                    <table class="table table-th-0 table-sm-td table-sm-th text-sm">
                                        <thead>
                                            <tr class="small">
                                                <th></th>
                                                <th class="text-center pb-3" style="font-size:10px;">Pencapaian</th>
                                                <th class="text-center pb-3" style="font-size:10px;">Saran</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in dataScoreComparison" :key="index" :class="item.prerequisite == 1 ? 'highlight-success':''">
                                                <td class="w-100 td-wrap font-bold m-0">{{ item.subject_name }}</td>
                                                <td class="text-center">
                                                    <div class="box-score box-warning" style="font-size:18px;">
                                                        <span>{{ item.average_score }}</span>
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <div class="box-score box-pink" style="font-size:18px;">
                                                        <span>{{ item.suggest_score }}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-block pt-4 border-top">
                    <div class="row">
                        <div class="col-3" v-for="(item, index) in dataChartDiagramRecap" :key="index">
                            <div class="card bg-card-trans">
                                <div class="card-body">
                                    <div class="block-ellipsis text-success mb-3 font-bold">{{ item.name }}</div>
                                    <div style="height: 200px">
                                        <LineChart :height="'200px'" :chart-data="item.chart" :chart-id="'chart-line-'+index"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="d-block ps-1">
                                <div class="d-flex align-items-center mb-2">
                                    <div class="box-skew-12 me-2 bg-pink-2"></div>
                                    <div class="d-block">Saran</div>
                                </div>
                                <div class="d-flex align-items-center mb-2">
                                    <div class="box-skew-12 me-2 bg-warning"></div>
                                    <div class="d-block">Pencapaian</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-block pt-4 border-top">
                    <table class="table table-th-0 table-td-border table-hover-1 table-th-border table-sm-td table-sm-th table-th-style-1 text-sm">
                        <thead>
                            <tr class="th-1">
                                <th class="text-pink" rowspan="2">Tabel Detail Perbandingan</th>
                                <th v-for="(item, index) in total_semester" :key="index" class="text-center" colspan="3">Semester {{ item }}</th>
                            </tr>
                            <tr>
                                <template v-for="(item, index) in total_semester">
                                    <th v-bind:key="index" class="text-center">Nilai</th>
                                    <th v-bind:key="index" class="text-center">Saran<br>Minimal</th>
                                    <th v-bind:key="index" class="text-center">Saran<br>Ideal</th>
                                </template>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in dataScoreComparison" :key="index">
                                <td class="font-bold">{{ item.subject_name }}</td>

                                <template v-for="(itemDetail, indexDetail) in item.list_score">
                                    <td v-bind:key="indexDetail" class="text-center">
                                        <div v-if="itemDetail.score" class="box-score box-score-sm-2" style="font-size:16px;" :class="itemDetail.class_btn">
                                            <span>{{ itemDetail.score}}</span>
                                        </div>
                                        <span v-if="!itemDetail.score">-</span>
                                    </td>
                                    <td v-bind:key="indexDetail" class="text-center">
                                        <div v-if="itemDetail.min_suggestion" class="box-score box-score-sm-2" style="font-size:16px;">
                                            <span>{{ itemDetail.min_suggestion }}</span>
                                        </div>
                                        <span v-if="!itemDetail.min_suggestion">-</span>
                                    </td>
                                    <td v-bind:key="indexDetail" class="text-center">
                                        <div v-if="itemDetail.ideal_suggestion" class="box-score box-score-sm-2" style="font-size:16px;">
                                            <span>{{ itemDetail.ideal_suggestion }}</span>
                                        </div>
                                        <span v-if="!itemDetail.ideal_suggestion">-</span>
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div>
                    <vue-html2pdf
                        :show-layout="false"
                        :float-layout="true"
                        :enable-download="true"
                        :preview-modal="false"
                        :filename="'Hasil Rasionalisasi - '+dataUsers.fullname+' ('+dataUsers.school_name+')'"
                        :paginate-elements-by-height="1100"
                        :pdf-quality="2"
                        pdf-format="a4"
                        pdf-orientation="landscape"
                        pdf-content-width="800px"
                        :manual-pagination="false"

                        @progress="onProgress($event)"
                        @hasDownloaded="hasDownloaded($event)"
                        ref="html2Pdf"
                        >

                        <ContentToPrint slot="pdf-content" :dataUsers="dataUsers" :dataEvaluation="dataEvaluation" :dataScoreComparison="dataScoreComparison" :dataChartRecap="dataChartRecap" :dataMajorRank="dataMajorRank" :description_labels="description_labels"/>                        
                    </vue-html2pdf>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import RadarChart from '../../components/chart/Radar.vue'
import LineChart from '../../components/chart/Line.vue'
import VueHtml2pdf from 'vue-html2pdf'
import ContentToPrint from "../../components/print/main.vue";
export default {
    name: 'RationalizationFormAchievement',
    data() {
        return {
            dataFetch       : false,
            dataUsers  : [],
            dataEvaluation  : [],
            dataScoreComparison  : [],
            dataChartRecap : [],
            dataChartDiagramRecap : [],
            dataMajorRank : [],
            description_labels : [],
            total_semester  : 5,
            fetch_download : false
        }
    },
    components: {
      RadarChart,
      LineChart,
      VueHtml2pdf,
      ContentToPrint
    },
    created() {
        if(this.$route.query.type == 'major' || this.$route.query.type == 'group_subject') {
            this.getEvaluationMajor();
        } else {
            this.getEvaluation();
        }
    },
    methods: {
        getEvaluation: function() {
            this.dataFetch      = true;
            this.dataEvaluation = [];
            this.dataScoreComparison = [];
            this.dataUsers = [];
            let uri         = process.env.VUE_APP_APIHOST+'rationalization/evaluation';
            this.$http.get(uri,{
                params : {
                    id    : this.$route.params.id,
                    code    : this.$route.params.code,
                    statistic : 1
                }
            }).then(res => {
                this.dataFetch      = false;
                if(res.data.status) {
                    this.dataUsers              = res.data.data.users;
                    this.dataEvaluation         = res.data.data.evaluation;
                    this.dataScoreComparison    = res.data.data.score_comparison;
                    this.dataChartRecap         = res.data.data.chart_recap;
                    this.dataChartDiagramRecap  = res.data.data.chart_data_diagram_recap;
                    this.dataMajorRank          = res.data.data.major_rank;
                    this.description_labels     = res.data.data.description_labels;
                }
             });
        },
        getEvaluationMajor: function() {
            this.dataFetch      = true;
            this.dataEvaluation = [];
            this.dataScoreComparison = [];
            this.dataUsers = [];
            let uri         = process.env.VUE_APP_APIHOST+'rationalization/evaluation-alt-major';
            this.$http.get(uri,{
                params : {
                    id    : this.$route.params.id,
                    code    : this.$route.params.code,
                    type : this.$route.query.type,
                    statistic : 1
                }
            }).then(res => {
                this.dataFetch      = false;
                if(res.data.status) {
                    this.dataUsers              = res.data.data.users;
                    this.dataEvaluation         = res.data.data.evaluation;
                    this.dataScoreComparison    = res.data.data.score_comparison;
                    this.dataChartRecap         = res.data.data.chart_recap;
                    this.dataChartDiagramRecap  = res.data.data.chart_data_diagram_recap;
                    this.dataMajorRank          = res.data.data.major_rank;
                    this.description_labels          = res.data.data.description_labels;
                }
             });
        },
        goDetail: function( ) {
            this.$router.push({
                name : 'rationalization_form_edit',
                params: { code: this.$route.params.code }
            });
        },
        onProgress(event) {
            this.fetch_download = true;
            if(event >= 100) {
                this.fetch_download = false;
            }                
        },
        hasDownloaded(event) {
            console.log(`Processed: ${event} / 100`);
        },
        hasGenerated() {
            alert("PDF generated successfully!");
        },
        printRationalization() {
            this.$refs.html2Pdf.generatePdf();                
        },
    }
}
</script>